<template>
	<div class="absolute inset-x-0 bottom-0 z-20 p-1">
		<div class="h-[2px] w-full overflow-hidden">
			<div class="h-full w-full animate-video-loading-bar bg-white" />
		</div>
	</div>
</template>
